$(() => {

    /* Störer schließen */
    $(".interferer-btn-close").on({
        click: (e) => {
             $(".interferer-opened").addClass("hide");
             $(".interferer-closed").removeClass("hide");
             $(".interferer-closed").removeClass("d-none");
             sessionStorage.setItem("interferer",1);
        }
    });
    $(".interferer-btn-open").parent().parent().on({
        click: (e) => {
             $(".interferer-opened").removeClass("hide");
             $(".interferer-closed").addClass("hide");
        }
    });

    // if (window.location.pathname === '/stellenangebote' || alle Seiten im Jobmenue) {
    //     $(".interferer-opened").addClass("d-none");
    // }
    if(sessionStorage.getItem("interferer")){
        $(".interferer-closed").removeClass("hide");
    }else{
        $(".interferer-opened").removeClass("hide");
    }

})